jQuery( document ).ready(function() {

  if($('.simpleheader').length > 0) {

    $( ".simpleheader_mobiletrigger" ).click(function() {
      $( ".simpleheader_mobilebar" ).toggleClass( "simpleheader_mobilebar-active" );
      $( ".simpleheader_mobilemenu" ).slideToggle();
    });
    $( ".simpleheader_mobilehaschild" ).click(function() {
      $(this).next(".simpleheader_mobilechildren").slideToggle();
      $(this).prev(".simpleheader_arrow").toggleClass("simpleheader_arrow-active");
    });

    $( ".simpleheader_haschild").click(function(){
      $( ".simpleheader_children").toggle;
      console.log("test");
    });

  }
});